module.exports = __webpack_public_path__ + "static/media/We Shall Overcome.30c40fef.jpg";